import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import request from '@/router/axios';
export var getList = function getList(current, size, params, deptId) {
  return request({
    url: '/api/blade-user/page',
    method: 'get',
    params: _objectSpread(_objectSpread({}, params), {}, {
      current: current,
      size: size,
      deptId: deptId
    })
  });
};
export var remove = function remove(ids) {
  return request({
    url: '/api/blade-user/remove',
    method: 'post',
    params: {
      ids: ids
    }
  });
};
export var add = function add(row) {
  return request({
    url: '/api/blade-user/submit',
    method: 'post',
    data: row
  });
};
export var update = function update(row) {
  return request({
    url: '/api/blade-user/update',
    method: 'post',
    data: row
  });
};
export var updatePlatform = function updatePlatform(userId, userType, userExt) {
  return request({
    url: '/api/blade-user/update-platform',
    method: 'post',
    params: {
      userId: userId,
      userType: userType,
      userExt: userExt
    }
  });
};
export var getUser = function getUser(id) {
  return request({
    url: '/api/blade-user/detail',
    method: 'get',
    params: {
      id: id
    }
  });
};
export var getUserPlatform = function getUserPlatform(id) {
  return request({
    url: '/api/blade-user/platform-detail',
    method: 'get',
    params: {
      id: id
    }
  });
};
export var getUserInfo = function getUserInfo() {
  return request({
    url: '/api/blade-user/info',
    method: 'get'
  });
};
export var resetPassword = function resetPassword(userIds) {
  return request({
    url: '/api/blade-user/reset-password',
    method: 'post',
    params: {
      userIds: userIds
    }
  });
};
export var updatePassword = function updatePassword(oldPassword, newPassword, newPassword1) {
  return request({
    url: '/api/blade-user/update-password',
    method: 'post',
    params: {
      oldPassword: oldPassword,
      newPassword: newPassword,
      newPassword1: newPassword1
    }
  });
};
export var updateInfo = function updateInfo(row) {
  return request({
    url: '/api/blade-user/update-info',
    method: 'post',
    data: row
  });
};
export var grant = function grant(userIds, roleIds) {
  return request({
    url: '/api/blade-user/grant',
    method: 'post',
    params: {
      userIds: userIds,
      roleIds: roleIds
    }
  });
};